
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexiKTvvvDtDWhv3S_45G_3VttozCHxO2XdNBN4jf9iQHk_MMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/index.vue?macro=true";
import { default as loginPMP_2G_456_454usauw88MP8BhPn9gMAqFr8pLUt8BptEdEMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/login.vue?macro=true";
import { default as verify_459i9M_45AEeQcpfWTGtAMBpkkxV9DDze54te0smzGRLw0Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/verify.vue?macro=true";
import { default as sitemapks_h4mI4pHVKz9NuaF_45QM1uvmIckyk4U6mor6QD1VA4Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/sitemap.vue?macro=true";
import { default as about_45usKnckbSHC6YermhRtplNDsk2EHu3NuBXmH594ACSUy0gMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/about-us.vue?macro=true";
import { default as registerrlh4Ul0H494TAYIjWhmpr_QdxUID4cgCxKtsGKhmiHYMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/register.vue?macro=true";
import { default as complaintskqSq2a5J3EbGrylpu_Z5UBCwjMmvY8qtvOugnf7Zdn8Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/complaints.vue?macro=true";
import { default as contact_45usjaiZRkz71uUDHBY7DAsrjP9gD2GvNNQ2c9NBWKCCs8cMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/contact-us.vue?macro=true";
import { default as indexpKmX8I8hdBK3dRJSffHlD_45O4kHKEWif8XRQbTVA3dIUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/media/index.vue?macro=true";
import { default as indexFl5YfuC40wDO28So8hjheIceb9Jx4msCcEx550WaqiUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/index.vue?macro=true";
import { default as _91slug_93BCOh7lUu8E74j_45oTPoALKfGLep6G9KbuN5yb3pODnJcMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/media/[slug].vue?macro=true";
import { default as partnershipswWHe0OtmoDX7xX4Xz7SchU1lkLAxMqbifeqjBdYfLkQMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/partnerships.vue?macro=true";
import { default as terms_45of_45use1Q3s0znI9vBVdFR4p3cGYyJdNa7f_45GHGen9me58p_45I4Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/terms-of-use.vue?macro=true";
import { default as indexGBNavflugfUBl_GIt1B3NqoCp4zBp6AvOlIw5D6D3fAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/careers/index.vue?macro=true";
import { default as privacy_45policylvYJE2J_8mDP30pkLEOcxcQzfUZba2p2iflTKgPxqJQMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordTulLPG6hCsQRAJNp35Cg4gQs30Gs6QnQaW0oMv0Gp_kMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/reset-password.vue?macro=true";
import { default as index7VvI27gq_jSVYOj5yhat_45wF3Ui0UU5DEyijhci1XemgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/car-loans/index.vue?macro=true";
import { default as indexZBIpqgMx71q6goGb2ruSO5PboeNdbTU_45Td08yS5VSokMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/index.vue?macro=true";
import { default as legalRlOdD06nKUCZs1Gq_45qOd39XwACDwf6twKpRc83IzEWgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/legal.vue?macro=true";
import { default as forgot_45password49bAjEkUDD4OoMsNoipRZzToi2YiM_45NzwUQJjFSZ0AoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/forgot-password.vue?macro=true";
import { default as errorKOxkbVzt5Oloi2s5k8T6_LNMYUquPp8eQS8GJ0G_45lHwMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/cdr/error.vue?macro=true";
import { default as indexASFlYE642H1Kg5Lu8Re0v7u4mxSfz_MxPGUMlvfV408Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/index.vue?macro=true";
import { default as _91slug_93v3YByaE9o5q36YyNkwr9cGBPVDrizE56x5ZHy1bVWnUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/[slug].vue?macro=true";
import { default as guidesjn6p7AVHhO_xktLsEC_45XZPoFMqoTarZYSE8nfvZHpuoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/guides.vue?macro=true";
import { default as collection_45noticepNuODoissz9Mlbc0FcIjY1jtXUSpZoRyHs61a_YOmgoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/collection-notice.vue?macro=true";
import { default as indexEirSKCjStZ7VKrs7nTeq8TVJoxpdTG_45artMLLnOSY7sMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/credit-cards/index.vue?macro=true";
import { default as set_45password65yWVi4Yd9mKE_F6vrEGrPwJ9fFR2_V1p3l4fLVnxZoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/guest/set-password.vue?macro=true";
import { default as welcome_45backfDDeLcRmBAFFXTuv7MAe3_8ibUZ0PA8Sh5B6Wm2ckm4Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/guest/welcome-back.vue?macro=true";
import { default as mergeMGhSSrYJWlXIrsf230y4DOezvn6KILkF_45b0eZg0YzrMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/authorization/merge.vue?macro=true";
import { default as indexBBWoU8jjk7kYwS5J7Zcr4mGG2_45dw5vLoB9OKR0LYTWIMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/index.vue?macro=true";
import { default as _91slug_937_45cQLMbKKOCQYPTieXNqcou1jMxxpBiZlEgL4diXH1YMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/credit-cards/[slug].vue?macro=true";
import { default as post_45sale_45thank_45youMt1d_45Nwi8W5U8xt94p5EgkhBji7tWQrpWCKs9OvXkZ0Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/post-sale-thank-you.vue?macro=true";
import { default as thank_45youurv8nTbZ_45fvpwyKC2FBfGmw__45U1lSzGE79dUGhRfAbgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/cdr/thank-you.vue?macro=true";
import { default as indexz_45lB61iTL0ATlkPntnmvQ3rF_CYinQ_FFvT9WWmQLz4Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/index.vue?macro=true";
import { default as indexqwU4IDTcw1YlHfVFBvG8uxXwIReU_45o0GPE4eHNar3fAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/personal-loans/index.vue?macro=true";
import { default as _91slug_93x0EXe_K_45KF_k7sSdm0hbC9KnGroVImcJEFjXGiLiGM4Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/preview/media/[slug].vue?macro=true";
import { default as indexi11QOgcFh7cn8irycBLBHu6eaKXiJiBoE_rb2UDNGoUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/perks/index.vue?macro=true";
import { default as indexPRmWU4oiG_45WgR3yKQOuCM5WdS_2CuM8zUaiClYxEwI0Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/expert-analysis/index.vue?macro=true";
import { default as _91author_93ZD5d_vq3nPK2_45X7CgLhyq7KHcEkLe74X9TwziEjOGMgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/media/author/[author].vue?macro=true";
import { default as callbackr6GKcPEgm0Is6LfTVWmAKSDc3O9OIEOymCZl67wJ14oMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/authorization/callback.vue?macro=true";
import { default as buyer_45protection_45claimniYVZKAWePyE22ueOZAANGZyKrZ4zKRw7N9XcGD66QUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/buyer-protection-claim.vue?macro=true";
import { default as index8gdxPwMxFzsll_45iVyGk5YYB2r2TKRREEmzWZRTg_45_45wIMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/quotes/index.vue?macro=true";
import { default as thank_45youXoojAbjR4L_45AlYDkTQSkDpZN4MYF2iMmP54A31uMY6cMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/quote/thank-you.vue?macro=true";
import { default as error3G_FL1Hnpoen1ce2eOa_45C0mP4um9CUc_dbsTQcQY4WYMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/error.vue?macro=true";
import { default as indexKfMnePwvQPI4dwOe9HKLroS3_okPXmER2HMHNcKjfAAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/index.vue?macro=true";
import { default as indexyrD3aLE8fnrNxy91Fna0zOX_45ZRWgfrN_45VTjkFT9ILZQMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/rewards/index.vue?macro=true";
import { default as error2Z2muPWe0Kvxxf_45f05etHKdhYQhxb4bIYXbH0wZPj7cMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/application/error.vue?macro=true";
import { default as _91step_93RHyw5S9822QzXIVUotqLi__2SLiQUAHM72uxbMcLKK8Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/quote/form/[step].vue?macro=true";
import { default as detailsFOtSUMgk8TlsH4e2RtXGAelk1qKN9_4qXsDInyb18p8Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/quote/form/details.vue?macro=true";
import { default as interest_45ratesidfyTUx8zivjeOwfrYNpzUne97CcN6qVZcLyWcQixOgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/interest-rates.vue?macro=true";
import { default as _91slug_93bNsTpLP0f7lFjThYg0WCPu1AawpfKs2YUf_45_45aFOCbqMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/preview/[vertical]/[slug].vue?macro=true";
import { default as index3y6a1Jy8e43JQXz9gT8xYkLUEO_45AtKB2TAOboK5y_45eAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/companies/index.vue?macro=true";
import { default as account_45settingsHCm9rx6ZgY7sNZOFy0H_zBDW5FF_XYXCfL3ublJZ3XgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/account-settings.vue?macro=true";
import { default as indexMy5Xw3vQmFustPcNBPVqFY7BT2wxrP3oR_451hnknWbw8Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/onboarding/index.vue?macro=true";
import { default as live_45chatRClOgwvrjM2d6Mw4vzlzmVlsk_45ZDy13A7BetJWQkEZgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/live-chat.vue?macro=true";
import { default as post_45saleyKoiC2OFPxtdTewR6fquqf2eAu9HtSjhfL3nTw1Pf4YMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/post-sale.vue?macro=true";
import { default as thank_45you6geQefUavZgwJ7dKywxZ5uVNB24_nPf9twG_pg_456ozIMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/quote/thank-you.vue?macro=true";
import { default as comprehensiveIYLYPv_45rhLGrl_E8_451_dW6fJnin1CViqRdJpkvfDg9AMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/comprehensive.vue?macro=true";
import { default as _91slug_93CaQglsP3b2X57_45bXaMSkzFScSZQt_2BHATRAo7TarDMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/credit-cards/preview/[slug].vue?macro=true";
import { default as addCWzk5FEv0XxDtxzOWFCKAGjJPy8UARI1__lvccsbTm4Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/partners/add.vue?macro=true";
import { default as indexb5ZUbKlPwCHJs0qYUkrrlukjxCwx1XDBISUvr3l6FUkMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue?macro=true";
import { default as _91response_93txP9L8xFnzLquQSZWnm809E2S8RUrDnCqnCx3EqrWWAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue?macro=true";
import { default as schedule_45callbackZZ2fe_cics_GuQS8RIINnN2EsaQxcOCRHAPBA4OkTTMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/schedule-callback.vue?macro=true";
import { default as _91slug_93bJV0uv5rWivLiLaxIIkDyJuZoggd8_45RRrkoAKbZXiskMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue?macro=true";
import { default as thank_45youniuvrYj3QNFxjIdKRq_45cz51_45bQ0pIWoClUNKne3_45ILAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/application/thank-you.vue?macro=true";
import { default as live_45chat_45bT_ITX4eu2LppI_45_457RltJfOZo69VojC_45XneUgxRH8ylcMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/live-chat-b.vue?macro=true";
import { default as indexMwtHzaegEqwlYeJ9G2nePGsGIlWP_45zgFmczmH5GHHeEMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/calculators/index.vue?macro=true";
import { default as _91step_93e8DQ0lXf_45kl_45frTtmCd9yJtP0CUk2UxQtNp_453b3BaIMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_93h6_45godRx0oAC9diiygTAloDImOBlD3JmLn6S37a6sx0Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue?macro=true";
import { default as indexeJG8YG0F3ia8DRliGsZFd7Zp0aMf7Qeit_45poIDS_45PBUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/offers/index.vue?macro=true";
import { default as addilqcvTDa71NBg9kBp_45oYd7K0lzWpOdhyApbn9aMYrNQMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/partners/add.vue?macro=true";
import { default as _91type_93dd00_ZGjyqZLbvWnF0nXJk4a2ZdiWWUhS3Xiq7JIbEkMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/calculators/[type].vue?macro=true";
import { default as detailsG9C95E7OC_lJY9CMTcegQ6LndmmTH2kF7JLlb1fQWcIMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/quote/form/details.vue?macro=true";
import { default as callbackjhH4REIBoqw3jRo8wf1BDfSvar5YBatua620_45JJ0Yx0Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/callback.vue?macro=true";
import { default as digital_45eic7oY9qXxc4OuQrc_45yAeVIo03kfYyavQcMobAgkcmZjUIMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/application/digital-eic.vue?macro=true";
import { default as thank_45youj35CjWqamB8neCXhViZziIlsJmgE8N0WcL24OJ6SwcoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue?macro=true";
import { default as _91step_93LWndoJj9BtVuyeZ1tsVIHK_4dQksAyArkgYwYWwUMisMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue?macro=true";
import { default as _91author_93ztKztNM1Lv_45yLs_45th_sCYJl2cYZ6j4cvJsTdYr2c4rkMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/expert-analysis/author/[author].vue?macro=true";
import { default as comparison3tKDt5GU285uNTnHTeYTAX5Gli1pfbDI72YgPFYOgSUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/comparison.vue?macro=true";
import { default as step18CECfTvnMGi_454OnONo2kp0hwP2lJEyGA07pkBFCcKWEMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/form/step1.vue?macro=true";
import { default as detailsnNohhV_K9ZYIjivtcUXShhHY9yEF5DAQdB_45P4dBMJNgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/quote/form/details.vue?macro=true";
import { default as results59_h5GUb21yfCScx1nJ88cdfRydOtUkOMYekO_lmr0MMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/quote/form/results.vue?macro=true";
import { default as indexObnNS0SEUXPZPfQXZy_45yLOe5pKXqOZbvnj73XdT80ZUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/expert-analysis/[category]/index.vue?macro=true";
import { default as signupb3jvewXdIOrCnWuOVQvhNdtz32SIma2PXunFPUA164AMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/partners/signup.vue?macro=true";
import { default as thank_45youHCdO_40x5uN4uFKNrOyvLuZGB_45Tejjqqrp7kMQWSFHUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue?macro=true";
import { default as _91step_93y0O9fguh_45mGNO2ExpBjuqRqFU7tAoBvZpHZ0RnxE5jQMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/form/[step].vue?macro=true";
import { default as _91step_93RiEd1fGCNwcr3yt_45fml8Ibs_OYkIoF4Fo1jOYWCQHXUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_939ekNgAn6ZQm21MpREeuUZKRRNntHTzA0cOg2dS1_45QpoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue?macro=true";
import { default as step0Vq5sA0blTwEY9SL6qaofSR96E975X2R1NLY3zIjy8G0Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue?macro=true";
import { default as existing_45customersnJGjXW5kJa6_45plN0ACZN14ltIdc5A2OG08joOydxIGAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/existing-customers.vue?macro=true";
import { default as thank_45youY0T_TBhKAlB2BDSs9Yxxo1hVwGSF4uc3WdedFLJMElAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue?macro=true";
import { default as detailsnOkOzzKyCLeh0a_1VVz2DHIeKcMn_81kloz0wzwWSrcMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/form/details.vue?macro=true";
import { default as detailsYVxMpEe6UVUsfQH41zk9wwv_45T0cu0BnrstPZ1e4VqCMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/personal-loans/quote/form/details.vue?macro=true";
import { default as _91step_93v0nlsnK2wgCEqRnswvMZMrNCW2Qpspgh1vQULrrLGZgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue?macro=true";
import { default as rebateBnQ5XVAHss3t1F0kI8kSlMwnBCkSKJs6mqdEZ7iaKO0Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue?macro=true";
import { default as _91step_934gFk4bHi19uYK1tsCHRC_uGvzjw1I6vWwjYmmkGuZXMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/application/[step].vue?macro=true";
import { default as detailsI9fvuzAp_Mt_txIZHanj9zfzsRDYo8mwSvvNJWCZ0FgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/form/details.vue?macro=true";
import { default as step02keYVk85oIsNtuHKaUDG_xpcWg8YZyf_HEJ38CbFR20Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue?macro=true";
import { default as indexHZjkheguDuKABOQBY6XLwfSpWH1uPchjEUfr8_ZiGxcMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue?macro=true";
import { default as indexgQOZA6Pl7Mt_mUu8kInAa4Rvx3_45jBDIRvf66wGSJ_45tAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue?macro=true";
import { default as detailspCKK30hTjilG6PN6Ug5bLGnZn_7tI5TJlNpw3cpfMMcMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue?macro=true";
import { default as terms_45and_45conditionsPl1uSunMziAvkUpFxQJYhtNs_45LIGpmUvh89YN1_eqmAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue?macro=true";
import { default as _91location_93qQLKGUNS6oqbrcwrYF5zNTaFpGV1JzLO7MrDm9Z_45HXgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/compare-by-location/[location].vue?macro=true";
import { default as indexb938OpYsi0I1JaIUGoEfcs28zoJ_N1lIXRS5EsZFupAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue?macro=true";
import { default as details2Lh7csU4LtFUZhqh1FdR60FhNqEZ8FKEq_450JPfomUlsMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue?macro=true";
import { default as indexp8i6k5tqLJkoGRuWmRYDksiNmTi664kzfal1IbPnmFoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue?macro=true";
import { default as success0_45O5Pb3VL_w8f4_452drkEcRXdtriaTSfVy3sk4Y46XKwMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue?macro=true";
import { default as claim_45offerhBDg7ZtDaCQcH0iQLf18jI5Ww_qb5KPZcTj76tZScIYMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue?macro=true";
import { default as lic_45detailsMfKj3fuc2pPBX0_45zNULv4xwJIBLKvyJK1hWLsJ9CvCIMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue?macro=true";
import { default as _91step_93BLmZK6xNVYhOxtfU_457D5xN8MhISwTbZIFj5KcEH8T6MMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue?macro=true";
import { default as index7RuxZyG9NMB4QwhbZpt8NIUu_4500RKHCzEHtu0W_DAcsMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue?macro=true";
import { default as _91slug_93hD_45oXn42fNUePyUT3aBI9LxeeYRuL9OqE8dVWSt_5YUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue?macro=true";
import { default as indexS1jK9nG_45sCR6fOmhXq225DNFRu4WWQm8y9LsjrjyurUMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/application/payment/index.vue?macro=true";
import { default as _91step_93Sc1Xxn3sa5kHf0nau03Vguj06X7YtewMkya5WqDDyN0Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue?macro=true";
import { default as index3Uh7pkvFkdMJMJ8dGejfvVpiTwsjjoyMcmrDN5ctmIoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue?macro=true";
import { default as indexGqMSa3mykU5TgqT0zTdLahvxmSd0Joo8zCXlQhEUf0oMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue?macro=true";
import { default as detailsXsgBC44GtE5IxABky68qqgWf7nkPfqhDckBLjX8LQ8MMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue?macro=true";
import { default as expired9f3cuBTaADVwEBVJhA_45HPxclKrsuXS_45en_45yDxhg60uwMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue?macro=true";
import { default as indexqcPB5Npp2ahpzq8wAQV_eFQseA3jSNX52Ba0JUcqlIgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue?macro=true";
import { default as thank_45youYJhv5M3uKSmmSMvYiSRSMv4LEKr387YqgcrxsWKwRMgMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue?macro=true";
import { default as detailsBh5CfpsoxG3eUGWeEX_jy7Bfa9j6fCL5CP01taT2jPkMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue?macro=true";
import { default as confirmationlLjxkI75PTxhOoaxxYbYwUHxhrdX2lO60C3HBOJT_kQMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue?macro=true";
import { default as completion6FM_45Bdot5izNlyMofqz8coGOZqSeG5zfZuLWoSORe0oMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue?macro=true";
import { default as quotes_45resultsM0jKClvbLQjGdUTWIjIxpr17b6ZzbX49WZvWpwguXNMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue?macro=true";
import { default as confirmationtha_aGC12XRespRhJdqBY_45rtqH2HcaRFqiw56OTYRgIMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue?macro=true";
import { default as _91step_93JbGjuQwrkvBk5fgN5UjxuQhJFTgQp7OSoR1OTIAvSrkMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue?macro=true";
import { default as _91step_93nr1ZFWu0dHyyxRxXMG8jIKSCytyrt_4568XoyAGu52P_EMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue?macro=true";
import { default as _91step_930YSj5f6QIX9Un5IOSDz__qEz_45kkNgJN2paatvIOqzt4Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue?macro=true";
import { default as _91step_93ONbbi1xP9jd1K4m0keZlzz8opInGRzAxsbmtGZEOUDoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue?macro=true";
import { default as indexQ2f_dcRIKKqx4NBXmistVvka53HDirAkMAS3qaMyZkMMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue?macro=true";
import { default as additional_45detailsXGQTt1vqMoxcIKs3ROEqRWkoZmFEI0ktHdJzHZUMIvAMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue?macro=true";
import { default as _91step_93vt9RcmZyW70gvburhE4ijxDIlMPNfeJG13pVIP8iIkQMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue?macro=true";
import { default as _91step_93QHdN80BP5yjC2XONctrQkIgSKMGppOfDYGoGBNRrKVoMeta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue?macro=true";
import { default as index8d1hmriGi19NpZVq81aVi1oE7gBitcrtBff46B78Af8Meta } from "/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginPMP_2G_456_454usauw88MP8BhPn9gMAqFr8pLUt8BptEdEMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/login.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/verify.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/sitemap.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/about-us.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerrlh4Ul0H494TAYIjWhmpr_QdxUID4cgCxKtsGKhmiHYMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/register.vue")
  },
  {
    name: "complaints",
    path: "/complaints",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/complaints.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/contact-us.vue")
  },
  {
    name: "media",
    path: "/media",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/media/index.vue")
  },
  {
    name: "energy",
    path: "/energy",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/index.vue")
  },
  {
    name: "media-slug",
    path: "/media/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/media/[slug].vue")
  },
  {
    name: "partnerships",
    path: "/partnerships",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/partnerships.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/terms-of-use.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/careers/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordTulLPG6hCsQRAJNp35Cg4gQs30Gs6QnQaW0oMv0Gp_kMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/reset-password.vue")
  },
  {
    name: "car-loans",
    path: "/car-loans",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/car-loans/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexZBIpqgMx71q6goGb2ruSO5PboeNdbTU_45Td08yS5VSokMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-legal",
    path: "/dashboard/legal",
    meta: legalRlOdD06nKUCZs1Gq_45qOd39XwACDwf6twKpRc83IzEWgMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/legal.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password49bAjEkUDD4OoMsNoipRZzToi2YiM_45NzwUQJjFSZ0AoMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/forgot-password.vue")
  },
  {
    name: "energy-cdr-error",
    path: "/energy/cdr/error",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/cdr/error.vue")
  },
  {
    name: "home-loans",
    path: "/home-loans",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/index.vue")
  },
  {
    name: "vertical-slug",
    path: "/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/[slug].vue")
  },
  {
    name: "vertical-guides",
    path: "/:vertical()/guides",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "collection-notice",
    path: "/collection-notice",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/collection-notice.vue")
  },
  {
    name: "credit-cards",
    path: "/credit-cards",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/credit-cards/index.vue")
  },
  {
    name: "guest-set-password",
    path: "/guest/set-password",
    meta: set_45password65yWVi4Yd9mKE_F6vrEGrPwJ9fFR2_V1p3l4fLVnxZoMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/guest/set-password.vue")
  },
  {
    name: "guest-welcome-back",
    path: "/guest/welcome-back",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/guest/welcome-back.vue")
  },
  {
    name: "authorization-merge",
    path: "/authorization/merge",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/authorization/merge.vue")
  },
  {
    name: "car-insurance",
    path: "/car-insurance",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/index.vue")
  },
  {
    name: "credit-cards-slug",
    path: "/credit-cards/:slug()",
    meta: _91slug_937_45cQLMbKKOCQYPTieXNqcou1jMxxpBiZlEgL4diXH1YMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/credit-cards/[slug].vue")
  },
  {
    name: "post-sale-thank-you",
    path: "/post-sale-thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/post-sale-thank-you.vue")
  },
  {
    name: "energy-cdr-thank-you",
    path: "/energy/cdr/thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/cdr/thank-you.vue")
  },
  {
    name: "life-insurance",
    path: "/life-insurance",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/index.vue")
  },
  {
    name: "personal-loans",
    path: "/personal-loans",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/personal-loans/index.vue")
  },
  {
    name: "preview-media-slug",
    path: "/preview/media/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/preview/media/[slug].vue")
  },
  {
    name: "dashboard-perks",
    path: "/dashboard/perks",
    meta: indexi11QOgcFh7cn8irycBLBHu6eaKXiJiBoE_rb2UDNGoUMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/perks/index.vue")
  },
  {
    name: "expert-analysis",
    path: "/expert-analysis",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/expert-analysis/index.vue")
  },
  {
    name: "media-author-author",
    path: "/media/author/:author()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/media/author/[author].vue")
  },
  {
    name: "authorization-callback",
    path: "/authorization/callback",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/authorization/callback.vue")
  },
  {
    name: "buyer-protection-claim",
    path: "/buyer-protection-claim",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/buyer-protection-claim.vue")
  },
  {
    name: "dashboard-quotes",
    path: "/dashboard/quotes",
    meta: index8gdxPwMxFzsll_45iVyGk5YYB2r2TKRREEmzWZRTg_45_45wIMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/quotes/index.vue")
  },
  {
    name: "energy-quote-thank-you",
    path: "/energy/quote/thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/quote/thank-you.vue")
  },
  {
    name: "health-insurance-error",
    path: "/health-insurance/error",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/error.vue")
  },
  {
    name: "health-insurance",
    path: "/health-insurance",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/index.vue")
  },
  {
    name: "dashboard-rewards",
    path: "/dashboard/rewards",
    props: indexyrD3aLE8fnrNxy91Fna0zOX_45ZRWgfrN_45VTjkFT9ILZQMeta?.props ?? {"verificationNeeded":true},
    meta: indexyrD3aLE8fnrNxy91Fna0zOX_45ZRWgfrN_45VTjkFT9ILZQMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/rewards/index.vue")
  },
  {
    name: "energy-application-error",
    path: "/energy/application/error",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/application/error.vue")
  },
  {
    name: "energy-quote-form-step",
    path: "/energy/quote/form/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/quote/form/[step].vue")
  },
  {
    name: "energy-quote-form-details",
    path: "/energy/quote/form/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/quote/form/details.vue")
  },
  {
    name: "home-loans-interest-rates",
    path: "/home-loans/interest-rates",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/interest-rates.vue")
  },
  {
    name: "preview-vertical-slug",
    path: "/preview/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/preview/[vertical]/[slug].vue")
  },
  {
    name: "vertical-companies",
    path: "/:vertical()/companies",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  },
  {
    name: "dashboard-account-settings",
    path: "/dashboard/account-settings",
    meta: account_45settingsHCm9rx6ZgY7sNZOFy0H_zBDW5FF_XYXCfL3ublJZ3XgMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/account-settings.vue")
  },
  {
    name: "dashboard-onboarding",
    path: "/dashboard/onboarding",
    meta: indexMy5Xw3vQmFustPcNBPVqFY7BT2wxrP3oR_451hnknWbw8Meta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/onboarding/index.vue")
  },
  {
    name: "health-insurance-live-chat",
    path: "/health-insurance/live-chat",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/live-chat.vue")
  },
  {
    name: "health-insurance-post-sale",
    path: "/health-insurance/post-sale",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/post-sale.vue")
  },
  {
    name: "home-loans-quote-thank-you",
    path: "/home-loans/quote/thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-comprehensive",
    path: "/car-insurance/comprehensive",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/comprehensive.vue")
  },
  {
    name: "credit-cards-preview-slug",
    path: "/credit-cards/preview/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/credit-cards/preview/[slug].vue")
  },
  {
    name: "life-insurance-partners-add",
    path: "/life-insurance/partners/add",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/partners/add.vue")
  },
  {
    name: schedule_45callbackZZ2fe_cics_GuQS8RIINnN2EsaQxcOCRHAPBA4OkTTMMeta?.name,
    path: "/:vertical()/schedule-callback",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/schedule-callback.vue"),
    children: [
  {
    name: "vertical-schedule-callback",
    path: "",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue")
  },
  {
    name: "vertical-schedule-callback-response",
    path: ":response()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue")
  }
]
  },
  {
    name: "credit-cards-redirect-slug",
    path: "/credit-cards/redirect/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue")
  },
  {
    name: "energy-application-thank-you",
    path: "/energy/application/thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/application/thank-you.vue")
  },
  {
    name: "health-insurance-live-chat-b",
    path: "/health-insurance/live-chat-b",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/live-chat-b.vue")
  },
  {
    name: "home-loans-calculators",
    path: "/home-loans/calculators",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/calculators/index.vue")
  },
  {
    name: "home-loans-quote-form-step",
    path: "/home-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/quote/form/[step].vue")
  },
  {
    name: "car-insurance-redirect-slug",
    path: "/car-insurance/redirect/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue")
  },
  {
    name: "health-insurance-offers",
    path: "/health-insurance/offers",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/offers/index.vue")
  },
  {
    name: "health-insurance-partners-add",
    path: "/health-insurance/partners/add",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/partners/add.vue")
  },
  {
    name: "home-loans-calculators-type",
    path: "/home-loans/calculators/:type()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/calculators/[type].vue")
  },
  {
    name: "home-loans-quote-form-details",
    path: "/home-loans/quote/form/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/home-loans/quote/form/details.vue")
  },
  {
    name: "life-insurance-quote-callback",
    path: "/life-insurance/quote/callback",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/callback.vue")
  },
  {
    name: "energy-application-digital-eic",
    path: "/energy/application/digital-eic",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/application/digital-eic.vue")
  },
  {
    name: "personal-loans-quote-thank-you",
    path: "/personal-loans/quote/thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-quote-form-step",
    path: "/car-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-author-author",
    path: "/expert-analysis/author/:author()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/expert-analysis/author/[author].vue")
  },
  {
    name: "life-insurance-quote-comparison",
    path: "/life-insurance/quote/comparison",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/comparison.vue")
  },
  {
    name: "life-insurance-quote-form-step1",
    path: "/life-insurance/quote/form/step1",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/form/step1.vue")
  },
  {
    name: "car-insurance-quote-form-details",
    path: "/car-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/quote/form/details.vue")
  },
  {
    name: "car-insurance-quote-form-results",
    path: "/car-insurance/quote/form/results",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/car-insurance/quote/form/results.vue")
  },
  {
    name: "expert-analysis-category",
    path: "/expert-analysis/:category()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/expert-analysis/[category]/index.vue")
  },
  {
    name: "health-insurance-partners-signup",
    path: "/health-insurance/partners/signup",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/partners/signup.vue")
  },
  {
    name: "health-insurance-quote-thank-you",
    path: "/health-insurance/quote/thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue")
  },
  {
    name: "life-insurance-quote-form-step",
    path: "/life-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/form/[step].vue")
  },
  {
    name: "personal-loans-quote-form-step",
    path: "/personal-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-category-slug",
    path: "/expert-analysis/:category()/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue")
  },
  {
    name: "health-insurance-quote-form-step0",
    path: "/health-insurance/quote/form/step0",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue")
  },
  {
    name: "life-insurance-existing-customers",
    path: "/life-insurance/existing-customers",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/existing-customers.vue")
  },
  {
    name: "life-insurance-partners-thank-you",
    path: "/life-insurance/partners/thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue")
  },
  {
    name: "life-insurance-quote-form-details",
    path: "/life-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/form/details.vue")
  },
  {
    name: "personal-loans-quote-form-details",
    path: "/personal-loans/quote/form/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/personal-loans/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-form-step",
    path: "/health-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue")
  },
  {
    name: "dashboard-vault-product-rebate",
    path: "/dashboard/vault/:product([^/]*)*/rebate",
    meta: rebateBnQ5XVAHss3t1F0kI8kSlMwnBCkSKJs6mqdEZ7iaKO0Meta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue")
  },
  {
    name: "health-insurance-application-step",
    path: "/health-insurance/application/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/application/[step].vue")
  },
  {
    name: "health-insurance-quote-form-details",
    path: "/health-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-policy-step0",
    path: "/health-insurance/quote/policy/step0",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue")
  },
  {
    name: "health-insurance-quote-resume",
    path: "/health-insurance/quote/resume",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue")
  },
  {
    name: "life-insurance-quote-customer",
    path: "/life-insurance/quote/customer",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue")
  },
  {
    name: "dashboard-vault-product-details",
    path: "/dashboard/vault/:product([^/]*)*/details",
    meta: detailspCKK30hTjilG6PN6Ug5bLGnZn_7tI5TJlNpw3cpfMMcMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue")
  },
  {
    name: "buyer-protection-terms-and-conditions",
    path: "/buyer-protection/terms-and-conditions",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue")
  },
  {
    name: "energy-compare-by-location-location",
    path: "/energy/compare-by-location/:location()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/energy/compare-by-location/[location].vue")
  },
  {
    name: "health-insurance-quote-customer",
    path: "/health-insurance/quote/customer",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue")
  },
  {
    name: "health-insurance-quote-policy-details",
    path: "/health-insurance/quote/policy/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue")
  },
  {
    name: "health-insurance-quotes-results",
    path: "/health-insurance/quotes-results",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue")
  },
  {
    name: "life-insurance-quote-customer-success",
    path: "/life-insurance/quote/customer/success",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue")
  },
  {
    name: "dashboard-offers-vertical-claim-offer",
    path: "/dashboard/offers/:vertical()/claim-offer",
    meta: claim_45offerhBDg7ZtDaCQcH0iQLf18jI5Ww_qb5KPZcTj76tZScIYMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue")
  },
  {
    name: "dashboard-vault-product-lic-details",
    path: "/dashboard/vault/:product([^/]*)*/lic-details",
    meta: lic_45detailsMfKj3fuc2pPBX0_45zNULv4xwJIBLKvyJK1hWLsJ9CvCIMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue")
  },
  {
    name: "health-insurance-quote-policy-step-step",
    path: "/health-insurance/quote/policy/step/:step()",
    meta: _91step_93BLmZK6xNVYhOxtfU_457D5xN8MhISwTbZIFj5KcEH8T6MMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc",
    path: "/health-insurance/visitors-visa-ovhc",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue")
  },
  {
    name: "preview-expert-analysis-vertical-slug",
    path: "/preview/expert-analysis/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue")
  },
  {
    name: "health-insurance-application-payment",
    path: "/health-insurance/application/payment",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/application/payment/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-step",
    path: "/health-insurance/visitors-visa-ovhc/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue")
  },
  {
    name: "health-insurance-application-thankyou",
    path: "/health-insurance/application/thankyou",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue")
  },
  {
    name: "health-insurance-rate-rise-calculator",
    path: "/health-insurance/rate-rise-calculator",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-details",
    path: "/health-insurance/visitors-visa-ovhc/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue")
  },
  {
    name: "health-insurance-application-payment-expired",
    path: "/health-insurance/application/payment/expired",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue")
  },
  {
    name: "life-insurance-income-protection-quote",
    path: "/life-insurance/income-protection/quote",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-thank-you",
    path: "/health-insurance/visitors-visa-ovhc/thank-you",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue")
  },
  {
    name: "life-insurance-income-protection-quote-details",
    path: "/life-insurance/income-protection/quote/details",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-confirmation",
    path: "/health-insurance/visitors-visa-ovhc/confirmation",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-vertical-completion",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/completion",
    meta: completion6FM_45Bdot5izNlyMofqz8coGOZqSeG5zfZuLWoSORe0oMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-quotes-results",
    path: "/health-insurance/visitors-visa-ovhc/quotes-results",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue")
  },
  {
    name: "life-insurance-income-protection-quote-confirmation",
    path: "/life-insurance/income-protection/quote/confirmation",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-form-energy-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/energy/step/:step()",
    meta: _91step_93JbGjuQwrkvBk5fgN5UjxuQhJFTgQp7OSoR1OTIAvSrkMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-generic-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/generic/step/:step()",
    meta: _91step_93nr1ZFWu0dHyyxRxXMG8jIKSCytyrt_4568XoyAGu52P_EMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-application-step",
    path: "/health-insurance/visitors-visa-ovhc/application/:step()",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-home-loan-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/home-loan/step/:step()",
    meta: _91step_93ONbbi1xP9jd1K4m0keZlzz8opInGRzAxsbmtGZEOUDoMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-form",
    path: "/health-insurance/students-offer/:university()/form",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue")
  },
  {
    name: "dashboard-vault-product-vertical-additional-details",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/additional-details",
    meta: additional_45detailsXGQTt1vqMoxcIKs3ROEqRWkoZmFEI0ktHdJzHZUMIvAMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue")
  },
  {
    name: "dashboard-vault-product-form-life-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/life-insurance/step/:step()",
    meta: _91step_93vt9RcmZyW70gvburhE4ijxDIlMPNfeJG13pVIP8iIkQMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-health-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/health-insurance/step/:step()",
    meta: _91step_93QHdN80BP5yjC2XONctrQkIgSKMGppOfDYGoGBNRrKVoMeta || {},
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-terms-conditions",
    path: "/health-insurance/students-offer/:university()/terms-conditions",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue")
  },
  {
    name: "Guides",
    path: "/credit-cards/guides",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "Companies",
    path: "/credit-cards/companies",
    component: () => import("/codebuild/output/src3677965337/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  }
]